
import React from "react";
import  * as AiIcons from 'react-icons/ai';
import  * as IoIcons from 'react-icons/io';



export const SidebarData = [

{
    title : 'Home',
    path : '/es',
    icons: <AiIcons.AiFillHome/>,
    cName: 'nav-text'
},
{
    title : 'Embajadores',
    path : '/embajadores',
    icons: <IoIcons.IoIosPaper/>,
    cName: 'nav-text'
},
{
    title : 'Equipo Sobr',
    path : '/equiposobr',
    icons: <IoIcons.IoMdPeople/>,
    cName: 'nav-text'
},
{
    title : 'Términos y Políticas',
    path : '/terminosypolitica',
    icons: <IoIcons.IoMdPeople/>,
    cName: 'nav-text'
}
]